export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);

  newState.histories = payload

  return newState;
};
